import {PartDamageTypeEnum} from '@/models/digital-document-queue-sender-transfer-protocol-form-model';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function partDamageTypeNameFilter(type: PartDamageTypeEnum) {
  switch (type) {
    case PartDamageTypeEnum.Scratch:
      return i18n.t(LF.Scratch) as string;
    case PartDamageTypeEnum.Chip:
      return i18n.t(LF.Chip) as string;
    case PartDamageTypeEnum.Dent:
      return i18n.t(LF.Dent) as string;
    case PartDamageTypeEnum.Crack:
      return i18n.t(LF.Crack) as string;
    case PartDamageTypeEnum.Missing:
      return i18n.t(LF.Missing) as string;
    case PartDamageTypeEnum.Damage:
      return i18n.t(LF.Damage) as string;
    case PartDamageTypeEnum.Wear:
      return i18n.t(LF.Wear) as string;
    default: return '';

  }
}
